/**
 * MKS-314 — TanStack Query wrapper for `GET /api/instance-settings`.
 *
 * `staleTime: Infinity`, matching `useEnabledModules` rather than
 * `useReleaseFlagValues`: the instance locale and reporting currency change
 * roughly never, and re-reading them on every window focus would re-render
 * every money and date cell in the app for nothing. An admin who changes a
 * setting sees it after the settings mutation invalidates this key (the admin
 * page does) or on the next load.
 */
import { useQuery } from '@tanstack/react-query';
import { fetchInstanceSettings, type InstanceSettings } from '../services/api/instanceSettings';

export const INSTANCE_SETTINGS_QUERY_KEY = ['instance-settings'] as const;

export function useInstanceSettings(enabled: boolean) {
  return useQuery<InstanceSettings>({
    queryKey: INSTANCE_SETTINGS_QUERY_KEY,
    queryFn: fetchInstanceSettings,
    enabled,
    staleTime: Infinity,
  });
}
